"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BANNER_VIDEO = void 0;
const BANNER_VIDEO = exports.BANNER_VIDEO = 'banner-video';
